var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClearFilters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 753"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 45",
    x: -115,
    y: -124,
    width: 1592,
    height: 906,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 48",
    x: -62,
    y: -64,
    width: 1539,
    height: 803,
    fill: "#535DA9",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 755"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 45_2",
    x: -115,
    y: -124,
    width: 1592,
    height: 906,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 48_2",
    x: -55,
    y: -64,
    width: 1532,
    height: 803,
    fill: "#535DA9",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 51",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-55 -64H1477V172H-55V-64Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 243",
    d: "M4 8H20",
    stroke: "#979FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 244",
    d: "M8 13H16",
    stroke: "#979FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 245",
    d: "M10 18H14",
    stroke: "#979FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 972",
    className: "cross-line",
    x: 8.06055,
    y: 3.29289,
    width: 17,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(45 8.06055 3.29289)",
    fill: "#979FC3",
    stroke: "#E9ECF5"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -65,
    y: -70,
    width: 1552,
    height: 256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.847778 0 0 0 0 0.864889 0 0 0 0 0.933333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilters);
export default __webpack_public_path__ + "static/media/clear-filters.16b868e43fb101575d66cb46b5fff556.svg";
export { ForwardRef as ReactComponent };